import React, { useRef, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import {
    useStylesTF,
    useStylesLbl,
} from '../../../../St/Reports/UseStyle';
import { sto } from '../../../../Context/InshData';
import { Button, colors, FormControlLabel, Hidden } from '@material-ui/core';
import { SaleCheckbox } from '../../../../St/comps/UseStyle';
import { useTranslation } from "react-i18next";
import { restrictStates } from '../../../../services/restrictionService';
import { CloudUpload } from '@material-ui/icons';
import { menuBottonsFile } from '../../../Invs/BackEnd/components/SearchItemsFunction';


export default function RestrictionHead(props) {

    const {
        paramsAuto,
        params,
        onChange,
        onChangeAuto,
        AutoOptions,
        manualRest,
        repeatNotes,
        setRepeatNotes,
        IsOpen,
        handleDownload,
        setFile,
        prevent,
        prmis,
        getRestRecycle
    } = props;

    const claslbl = useStylesLbl();
    const clasTF = useStylesTF();
    const { t } = useTranslation(["forms", "translation"]);

    const [menPostion, setMenuPostion] = useState(null);
    const fileInputRef = useRef(null);
    const handleFileSelect = (event) => {
      const selected = event.target.files[0];
      setFile(selected);
    };
    const handleClickOutLine = () => {
      setMenuPostion(null);
    };
    const handleClickInLine = (e) => {
      e.preventDefault();
      setMenuPostion({
        x: e.pageX,
        y: e.pageY,
      });
    };
    const openFileDialog = () => {
        fileInputRef.current.click();
      };
    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={clasTF}
                        value={paramsAuto.branch}
                        onChange={(event, newValue) => {
                            onChangeAuto("branch", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={AutoOptions?.Branches}
                        disabled={sto.User_typei === 1 ? false : true}
                        disableClearable={true}
                        style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        renderInput={(params) => (
                            <TextField
                                id="user"
                                {...params}
                                label={t("branch")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            />
                        )}
                    />

                </Grid>
                <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="dateT"
                        label={t("restriction-no")}
                        type="number"
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        name="doc_no2" value={params.doc_no2}
                        onChange={onChange("doc_no2")} />
                </Grid>

                <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="datef"
                        label={t("restriction-date")}
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        type="date" format="YYYY-MM-DD"
                        name="date" value={params.date}
                        onChange={onChange("date")} />
                </Grid>
                {IsOpen ?
                    (
                        <>
                            <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                <Autocomplete
                                    classes={clasTF}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    value={paramsAuto.state}
                                    onChange={(event, newValue) => {
                                        onChangeAuto("state", newValue);
                                    }}
                                    id="controllable-states-demo"
                                    size="small"
                                    options={restrictStates}
                                    disableClearable={true}
                                    style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : t(option.label)
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            id="user"
                                            {...params}
                                            label={t("restriction-status")}
                                            variant="outlined"
                                            size="small"
                                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                        />
                                    )}
                                />

                            </Grid>
                        </>
                    ) :
                    (
                        <>
                            <Grid item lg={1} md={2} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                                <FormControlLabel
                                    id="showPaid"
                                    value="addProfSalary"
                                    name="showPaid"
                                    className={claslbl.clor}
                                    control={
                                        <SaleCheckbox
                                            checked={manualRest}
                                            onChange={(e) => {
                                                // setManualRest(e.target.checked);
                                                getRestRecycle(e.target.checked);
                                            }}
                                            color={"#f18584"}
                                        />
                                    }
                                    label={t("manual-restriction")}
                                    labelPlacement="end"
                                />
                            </Grid>

                            <Grid item lg={2} md={2} sm={4} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small" id="dateT"
                                    label=""
                                    type="number"
                                    className={clasTF.rootCust}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    disabled={!manualRest}
                                    InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                    name="rest_cycle_no" value={params.rest_cycle_no}
                                    onChange={onChange("rest_cycle_no")} />
                            </Grid>

                            <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                <Autocomplete
                                    classes={clasTF}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    value={paramsAuto.book_id}
                                    onChange={(event, newValue) => {
                                        onChangeAuto("book_id", newValue);
                                    }}
                                    id="controllable-states-demo"
                                    size="small"
                                    options={AutoOptions.AccountBooks}
                                    disableClearable={true}
                                    style={{ color: 'black', fontWeight: "bold", fontSize: "1rem" }}
                                    getOptionLabel={(option) =>
                                        typeof option === "string" ? option : option.name
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            id="user"
                                            {...params}
                                            label={t("book-type")}
                                            variant="outlined"
                                            size="small"
                                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                                        />
                                    )}
                                />

                            </Grid>
                        </>
                    )
                }



                <Grid item lg={4} md={4} sm={6} xs={12} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="dateT"
                        label={t("note")}
                        type="text"
                        className={clasTF.rootCust}
                        InputProps={{ className: claslbl.clrBlackTxt }}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        name="notes" value={params.notes}
                        onChange={onChange("notes")} />
                </Grid>

                <Grid item lg={2} md={2} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}>
                    <FormControlLabel
                        id="showPaid"
                        value="addProfSalary"
                        name="showPaid"
                        className={claslbl.clor}
                        control={
                            <SaleCheckbox
                                checked={repeatNotes}
                                onChange={(e) => {
                                    setRepeatNotes(e.target.checked);
                                }}
                                color={"#f18584"}
                            />
                        }
                        label={t("repeat-note-shift")}
                        labelPlacement="end"
                    />
                </Grid>
                {prmis?.ARCHIVE === true && (
                    <Grid item lg={1} md={1} sm={2} xs={2} >
                        {prevent ?
                            (
                                <>
                                    <Hidden smDown>
                                        <Button
                                            fullWidth
                                            autoFocus
                                            variant="contained"
                                            onClick={(e) => {
                                                openFileDialog();
                                            }}
                                            style={{
                                                background: colors.grey[300],
                                                ...{
                                                    paddingLeft: 0,
                                                    paddingRight: 0,
                                                },
                                            }}
                                            startIcon={<CloudUpload />}
                                        >
                                            {"  "}
                                        </Button>
                                    </Hidden>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        style={{ display: "none" }}
                                        onChange={handleFileSelect} />
                                </>
                            ) : (
                                <>
                                    <Hidden smDown>
                                        <Button
                                            fullWidth
                                            autoFocus
                                            variant="contained"
                                            color="#000"
                                            onClick={(e) => {
                                                handleClickInLine(e);
                                            }}
                                            style={{
                                                ...{
                                                    paddingLeft: 0,
                                                    paddingRight: 0,
                                                },
                                            }}
                                            startIcon={<CloudUpload />}
                                        >
                                            {"  "}
                                        </Button>
                                    </Hidden>

                                </>
                            )}


                    </Grid>
                )}
                {menPostion && menuBottonsFile(handleClickOutLine, openFileDialog, handleDownload, menPostion, fileInputRef, handleFileSelect)}

            </Grid>

        </React.Fragment>

    );

}